var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a-cascader',{attrs:{"change-on-select":"","options":_vm.list,"disabled":_vm.disabled,"placeholder":"请选择地区"},on:{"blur":_vm.handleBlur},model:{value:(_vm.areaValue),callback:function ($$v) {_vm.areaValue=$$v},expression:"areaValue"}})
}
var staticRenderFns = []

export { render, staticRenderFns }